<template>
    <div class=" marginL201 clearfix">
        <div class="yh-title">
            <img src="../../../images/shouru.png" alt="" style="margin-top:10px;margin-left:30px;">
        </div>
        <div class="yh-con">
            <div class="yh-cons">
                <p>为了保证您的财产安全，请输入您的登录密码！</p>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="登录密码:">
                        <el-input
                                type="password"
                                v-model="form.docPassword"
                                class="yh-input"
                                @keyup.enter.native="changes"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <!--<span style="margin-left:70%;font-size: 14px;">忘记密码</span>-->
                <br>
                <el-button type="primary"  @click="changes" class=" blue-btn h36 w200" style="margin-left:20%;margin-top:50px;">
                    下一步
                </el-button>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import Vue from  "vue";
    import axiosUtil from "../../utils/AxiosUtils.js";
    import {MessageBox,Message} from "element-ui";
    export default{
        data(){
            return {
                form: {
                    docPassword: ""
                }
            }
        },
        methods:{
            changes:function(){
                let _this=this;

                if(_this.form.docPassword.length<6){
                    Message({
                        showClose: true,
                        message: "密码不能少于6位",
                        type: "warning"
                    });
                    return;
                }
                let shaObj = new jsSHA("SHA-512", "TEXT");
                let newPwd = _this.form.docPassword.toLowerCase();// 密码不区分大小写
                shaObj.update(hex_md5(newPwd) + newPwd);
                let docNewPassword = shaObj.getHash("HEX");
                let options={
                    docPassword:docNewPassword,
                    token: localStorage.getItem("token"),
                    Service:"smarthos.user.doc.password.check"
                };
                axiosUtil(options, function(data){

                    _this.$router.push("/setUp/income");
                }, function(){
//                   MessageBox.confirm('密码输入错误, 请重新输入密码', '提示', {
//                       confirmButtonText: '确定',
//                       cancelButtonText: '取消',
//                       type: 'warning'
//                   })
                });
            }
        }
    }
</script>